// ThreeViewerWithTimeline.jsx
import React, { useState, useEffect, useRef } from "react";
import ThreeViewer from "./ThreeViewer";
import TimelineBar from "../viewer3d/TimelineBar";
import { getGanttData } from "../../../api/process";

const ThreeViewerWithTimeline = ({ gltfUrl, binUrl, weatherData, projectId }) => {
  const [activities, setActivities] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [playing, setPlaying] = useState(false);
  const timerRef = useRef(null);
  const [speed, setSpeed] = useState(1);

  useEffect(() => {
    if (!projectId) return;

    getGanttData(projectId)
      .then((data) => {
        // Map API data to Viewer expected format
        const mappedData = data.map(item => ({
             Id: item.activity_id || item.id,
             Name: item.name,
             StartDate: item.start_date || item.start,
             FinishDate: item.end_date || item.end,
             PercentComplete: item.progress || 0
        }));

        setActivities(mappedData);

        // 날짜 유효성 검증
        const validStartDates = mappedData
          .map((a) => new Date(a.StartDate))
          .filter((d) => !isNaN(d));
        const validFinishDates = mappedData
          .map((a) => new Date(a.FinishDate))
          .filter((d) => !isNaN(d));

        if (validStartDates.length === 0 || validFinishDates.length === 0) {
          console.error("유효한 날짜가 없음");
          return;
        }

        const min = new Date(Math.min(...validStartDates));
        const max = new Date(Math.max(...validFinishDates));
        const minStr = min.toISOString().split("T")[0];
        const maxStr = max.toISOString().split("T")[0];
        setMinDate(minStr);
        setMaxDate(maxStr);
        setCurrentDate(minStr);
      })
      .catch((err) => {
        console.error("활동 데이터 로드 실패:", err);
      });
  }, [projectId]);

  useEffect(() => {
    if (playing) {
      timerRef.current = setInterval(() => {
        setCurrentDate((prevDate) => {
          const next = new Date(prevDate);
          next.setDate(next.getDate() + 1);
          const nextStr = next.toISOString().split("T")[0];
          if (nextStr > maxDate) {
            clearInterval(timerRef.current);
            setPlaying(false);
            return maxDate;
          }
          return nextStr;
        });
      }, 1000 / speed);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [playing, speed, maxDate]);

  return (
    <div className="w-full h-full flex flex-col">
      <TimelineBar
        minDate={minDate}
        maxDate={maxDate}
        currentDate={currentDate}
        onChange={(date) => {
          setCurrentDate(date);
          setPlaying(false);
        }}
        playing={playing}
        onPlayToggle={() => setPlaying(!playing)}
        speed={speed}
        onSpeedChange={setSpeed}
      />
      <div className="flex-1 relative">
        <ThreeViewer
          gltfUrl={gltfUrl}
          binUrl={binUrl}
          currentDate={currentDate}
          activityData={activities}
          weatherData={weatherData}
        />
      </div>
    </div>
  );
};

export default ThreeViewerWithTimeline;
